import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../Common/TextInput';
import ActivityLoader from '../Common/ActivityLoader';
import Notification from '../Common/Notification';
import ajaxSchool from '../../util/remote/ajaxSchool';
import { useSchool } from '../../DataStore/SchoolContext';
import CallOut from '../Common/CallOut';
import { useTheme } from '../../DataStore/ThemeContext';

const reducer = (state, action)=>{
    if(action.type === "RESET"){
        return {...initialState}
    }
    return { ...state, [action.type]: action.value };
}

const initialState = {
    batchName: '',
    starts: '',
    ends: '',
    loading: false,
}


const NewBatch = () => {

    const [state, dispatch] = useReducer(reducer, initialState);
    const [info, setInfo] = useState('');
    const {getBatchListing} = useSchool();
    const {setSystemFunction} = useTheme();

    useEffect(()=>{
        setSystemFunction(()=>handleSave);
        return ()=> setSystemFunction(null);
    }, [state]);
    

    const handleSave=async()=>{
        setInfo('');
        const server_response = await ajaxSchool.addBatch(state.batchName, state.starts, state.ends);
        if(server_response.status==="OK"){
            dispatch({type: 'RESET'})
            setInfo(<Notification type="success" message={server_response.message} closable={false}/>)
            getBatchListing(true);
        }else{
            setInfo(<Notification type="danger" message={server_response.message} closable={false}/>)
        }

      
    }


    return (
        <form method='post' onSubmit={handleSave}>

            <CallOut
            title="Billing Batch"
            description="Billing batches define the periods during which students are billed within a financial year."
            />

                <div className="mb-2 mt-4">{info}</div>
                <TextInput
                      type='text'
                      label='Batch Name'
                      placeholder='Batch reference title'
                      leftIcon='fa fa-tag'
                      value={state.batchName}
                      onChange={e => dispatch({type: 'batchName', value: e.target.value})}
                      required
                      wrap
                    />

                    <TextInput
                      type='date'
                      label='Batch Start Date'
                      placeholder='Start Date'
                      leftIcon='fa fa-calendar-alt'
                      value={state.starts}
                      onChange={e => dispatch({type: 'starts', value: e.target.value})}
                      required
                      wrap
                    />


                    <TextInput
                      type='date'
                      label='Batch End Date'
                      placeholder='End Date'
                      leftIcon='fa fa-calendar-alt'
                      value={state.ends}
                      onChange={e => dispatch({type: 'ends', value: e.target.value})}
                      required
                      wrap
                    />


        </form>
    );
};

export default NewBatch;